import React from "react";
import { useHistory } from "react-router";
import styles from "./HomeLoyaltyGrid.module.scss";
import {
  ROUTE_MENU,
  REACT_APP_CLOUD_FRONT,
  ROUTE_ORDER,
  GUEST_USER,
} from "../../../constants";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useAuthState } from "../../../context/UserAuthentication";
import { useStoreLocation } from "../../../context/StoreLocation";

const HomeLoyaltyGrid = () => {
  const history = useHistory();
  const isItMobile = useCheckMobileScreen();
  const { authInfo } = useAuthState();
  const { locationInfo } = useStoreLocation();

  const handleMangoMogitoRedirect = () => {
    if (!locationInfo.selectedStore) {
      return `${ROUTE_MENU}/Desserts`;
    } else {
      return `${ROUTE_ORDER}/274?category_id=7`;
    }
  };
  return (
    <div className={`row ${styles.gridWrapper}`}>
      <div className="col-md-6 position-relative">
        {isItMobile ? (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/chocolateStrawberryMob.png`}
            alt="SunSHine"
            className="img-fluid"
            style={{ borderRadius: "9px", boxShadow: "-2px 2px 5px 0px #00000040" }}
          />
        ) : (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/chocolateStrawberry.png`}
            alt="SunSHine"
            className="img-fluid"
            style={{ height: "100%", borderRadius: "15px", boxShadow: "-2px 2px 5px 0px #00000040" }}
          />
        )}

        <div className={styles.textWrapper}>
          <div className="d-flex flex-column align-items-end">
            <div className="d-flex gap-2 flex-nowrap">
              <p className={`${styles.innerText} ${styles.innerSpacing} cz-ps-sm-24 f-s16 lh-normal font-helvetica-light text-nowrap ls-0`}>Fresh strawberries. Melted <br/>chocolate. Totally irresistible.</p>
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle opacity-0`}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/leaf.png`}
                  alt="leafImage"
                />
              </div>
            </div>

            <div className="d-flex flex-nowrap gap-2">
              <a
                onClick={() => {
                  history.push(handleMangoMogitoRedirect());
                }}
                className={`${styles.innerText} ${styles.innerSpacing} ${styles.innerLink} font-helvetica-light f-s16 gap-2 flex-nowrap d-flex`}
              >
                {" "}
                <span className="text-nowrap font-helvetica-light">Regular or mini?</span>
                <svg width="26" height="20" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.20312 10.5C1.3747 10.5 0.703125 11.1716 0.703125 12C0.703125 12.8284 1.3747 13.5 2.20313 13.5L2.20312 10.5ZM30.6222 13.0607C31.2079 12.4749 31.2079 11.5251 30.6222 10.9393L21.0762 1.3934C20.4904 0.807611 19.5407 0.807611 18.9549 1.3934C18.3691 1.97919 18.3691 2.92893 18.9549 3.51472L27.4402 12L18.9549 20.4853C18.3691 21.0711 18.3691 22.0208 18.9549 22.6066C19.5407 23.1924 20.4904 23.1924 21.0762 22.6066L30.6222 13.0607ZM2.20312 12L2.20313 13.5L29.5615 13.5V12V10.5L2.20312 10.5L2.20312 12Z" fill="#C33C1D"/>
</svg>

              </a>
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle p-0`}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/strawberry.png`}
                  alt="strawberry"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 mt-3 mt-md-0 position-relative">
        {!isItMobile ? (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/fallBanner.png`}
            alt="VeggieImage"
            style={{ height: "100%", borderRadius: "15px", boxShadow: "-2px 2px 5px 0px #00000040" }}
            className="img-fluid"
          />
        ) : (
          <img
            src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/fallBannerMob.png`}
            alt="VeggieImage"
            className="img-fluid"
              style={{ borderRadius: "9px", boxShadow: "-2px 2px 5px 0px #00000040" }}
          />
        )}

        <div className={`${styles.rightTextWrapper} ${styles.textWrapper}`}>
          <div className="d-flex flex-column align-items-start">
            <div className="d-flex gap-lg-4 gap-3 flex-nowrap">
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle p-0 d-flex align-items-center justify-content-center `}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/bowl.png`}
                  alt="bowlImage"
                  height={36}
                />
              </div>
              {
                isItMobile ?
                <p
                className={`${styles.innerText} ${styles.innerSpacingRight} fw-normal font-helvetica-light f-s16 lh-normal cz-ps-20 text-nowrap`}
              >
                Go full control freak. Build your  <br /> own protein bowl. You call the  <br /> shots, we bring the flavor.
              </p>
              :
              <p
              className={`${styles.innerText} ${styles.innerSpacingRight} font-helvetica-light f-s16 lh-normal cz-ps-20 text-nowrap`}
            >
              Go full control freak. Build your own protein <br /> bowl. You call the shots, we bring the flavor.
            </p>
              }
            </div>
            <div className="d-flex flex-nowrap gap-lg-4 gap-3">
              <div
                className={`${styles.innerText} ${styles.imagediv} rounded-circle opacity-0`}
              >
                <img
                  src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/bowl.png`}
                  alt="bowlImage"
                />
              </div>
              <a
                onClick={() => {
                  history.push("menu/Build Your Bowl");
                }}
                className={`${styles.innerText}  ${styles.innerLink} flex-nowrap d-flex gap-2`}
              >
                {" "}
                <span className="text-nowrap font-helvetica-light f-s16 lh-normal">Your bowl, your rules.</span>
                <svg
                  width="26"
                  height="20"
                  viewBox="0 0 32 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.20312 10.1292C1.3747 10.1292 0.703125 10.8007 0.703125 11.6292C0.703125 12.4576 1.3747 13.1292 2.20313 13.1292L2.20312 10.1292ZM30.6222 12.6898C31.2079 12.104 31.2079 11.1543 30.6222 10.5685L21.0762 1.02255C20.4904 0.436762 19.5407 0.436762 18.9549 1.02255C18.3691 1.60834 18.3691 2.55808 18.9549 3.14387L27.4402 11.6292L18.9549 20.1144C18.3691 20.7002 18.3691 21.65 18.9549 22.2358C19.5407 22.8215 20.4904 22.8215 21.0762 22.2358L30.6222 12.6898ZM2.20313 13.1292L29.5615 13.1292V10.1292L2.20312 10.1292L2.20313 13.1292Z"
                    fill="#0956A8"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeLoyaltyGrid;
